import { module } from 'modujs';
import { debounce } from '../utils/tickers'

export default class extends module {
    constructor(m) {
        super(m);
                
        this.$rows = Array.from(this.$('row'));
        this.$preview = this.$('preview')[0]
        this.allowPreview = this.getData('preview') != undefined;
        this.showPreview = false;

        this.previews = {}; 
        this.previewZ = 1;
        this.activePreview = false;

        this.events = {
            click: {
                'skip-list': 'onSkipList'
            }
        }
    }

    init() {
        this.onRowEnter = this.onRowEnter.bind(this)
        this.onRowLeave = this.onRowLeave.bind(this)

        // Debounce is disabled (delay 0) in the end, if we want to reenable it, make sure to fix glitch issue on mouseenter after a long mouseleave
        this.debouncedHighlight = debounce(this.highlight.bind(this), 0);

        if(this.allowPreview) {
            for(let row of this.$rows) {
                row.addEventListener('mouseleave', this.onRowLeave)
                row.addEventListener('mouseenter', this.onRowEnter)
            } 
        }
    }

    highlight(key, src) {
        if(!this.previews[key]) {
            const el = document.createElement('img');
            el.src = src;
            this.$preview.appendChild(el);

            this.previews[key] = {
                src,
                el
            };
        }

        this.activePreview?.classList?.remove('is-active');
        this.previewZ++;

        this.activePreview = this.previews[key].el;
        this.activePreview.style.zIndex = this.previewZ;
        this.activePreview.classList.add('stop-animations');
        
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.activePreview.classList.remove('stop-animations');
                this.activePreview.classList.add('is-active');
            })
        })
    }    

    onRowEnter(e) {
        this.showPreview = true;
        this.el.classList.toggle('-show-preview', this.showPreview)

        const { target } = e;
        const src = this.getData('preview', target);
        const key = this.getData('key', target);

        this.debouncedHighlight(key, src)
    }

    onRowLeave(e) {
        this.showPreview = false;
        this.el.classList.toggle('-show-preview', this.showPreview)

        requestAnimationFrame(() => {
            if(!this.showPreview)
                this.activePreview?.classList?.remove('is-active');
        })
    }    

    onSkipList() {
        this.$('end')[0]?.focus()
    }

    destroy() {
        if(this.allowPreview) {
            for(let row of this.$rows) {
                row.removeEventListener('mouseleave', this.onRowLeave)
                row.removeEventListener('mouseenter', this.onRowEnter)
            }
        }
    }
}
